import { l, palettes } from '@manychat/manyui'

import { IQuickReplyBlock } from 'common/builder/blocks/blockInterfaces'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import { FlowChartNextStep } from 'common/builder/components/chart/FlowChart/types/FlowChartNextStep'
import { INode } from 'common/builder/nodes/nodeInterfaces'

export const getContentNodeNextStep = ({
  node,
  quickReplyBlock,
}: {
  node: INode
  quickReplyBlock?: IQuickReplyBlock
}): FlowChartNextStep => {
  if (quickReplyBlock && quickReplyBlock.settings?.timeout) {
    return new FlowChartNextStepBuilder(quickReplyBlock.id)
      .withColor(palettes.semantic.danger)
      .withLabel(l.translate('If contact hasn’t engaged'))
      .build()
  }

  return new FlowChartNextStepBuilder(node.id).withLabel(l.translate('Next Step')).build()
}
